// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__UdERm","validationTips":"StatementDescriptor_validationTips__1BBq6"};